<script setup>
import { RouterView } from 'vue-router';
import { onMounted, ref } from 'vue';
import { instalarHeaderFooter } from 'https://arpen-header-footer-prod.codebit.biz/header-footer.min.js';
import { useAuthStore } from '@/stores/auth';
import helpers from '@/helpers';
import { buscaRegistroService } from './services/buscaRegistro';

const authStore = useAuthStore();

const applicationToken = ref(null);
const groupsUser = ref(null);
const MRE = ref(null);
const checkConsulado = ref(null);
const checkFuncao = ref(null);

onMounted(async () => {

  function getCookie(name) {
    let cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
          return cookieValue;
      }
    }
    return null;
  }

  groupsUser.value = getCookie("groups")
  var decodeToken = JSON.parse(atob(groupsUser.value))
  const arrayGroups = JSON.parse(decodeToken.message)
  groupsUser.value = JSON.parse(decodeToken.message)
  groupsUser.value = groupsUser.value.join().replace(/[/]/g, "")

  MRE.value = arrayGroups.includes("/MRE")

  let jsonSERPRO = {
    "cpf": authStore?.user?.cpf
  }

  const [dataSERPRO] = await Promise.all([
		buscaRegistroService.obterDadosSERPRO(jsonSERPRO)
	]);
  const dadosConsulado = dataSERPRO.data.retornoConsulado
  const dadosConsular = dataSERPRO.data.retornoConsular

  checkConsulado.value = dadosConsulado.success
  checkFuncao.value = dadosConsular.success

  if(dadosConsulado.success == true){
    var nomeConsulado = dadosConsulado.dados[0].nome
  }else{
    var nomeConsulado = authStore?.user?.name
  }

  if(dadosConsular.success == true){
    var funcaoConsular = dadosConsular.dados[0].funcao
  }else{
    var funcaoConsular = groupsUser.value
  }

  instalarHeaderFooter({
    usuario: {
      nome: nomeConsulado,
      cpf: authStore?.user?.cpf ? helpers.formatarCPF(authStore.user.cpf) : null,
      grupos: funcaoConsular,
      foto: ""
    },
    urlLogin: authStore?.urlLogin(),
    urlLogout: authStore?.urlLogout(),
    token: authStore?.getToken(),
  });

  applicationToken.value = getCookie("application-token")

});
</script>

<template>
  <div>
    <div id="header"></div> 
      <span v-if="(checkConsulado == false && checkFuncao == false) && MRE == false">
        <div class="container">
          <br /><br />
          
          <SerpTipography type="t3" tag="h3" class="col-span-8" style="font-size:40px; color:#666666;">
            Atenção
          </SerpTipography>
          <br /><br />
          <small>Usuário sem permissão para o acesso ao sistema</small>

          <br /><br /><br /><br />
        </div>
        
      </span>
      <span v-else>
        <RouterView />
      </span>
    <div id="footer"></div>
  </div>
</template>

<style scoped>
#main {
  min-height: 84vh;
}
</style>

<style scoped lang="scss">
@import 'https://arpen-header-footer-prod.codebit.biz/header-footer.css';
</style>